import React, {Component} from 'react';
import { Breadcrumb} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import PrinterForm from "../../components/printer/PrinterForm";



class Printer extends Component {

    render() {
        return (
            <div>
                <Helmet>
                    <title>Impresora - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Impresora</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <PrinterForm />
            </div>
        );
    }
}

export default Printer;



// WEBPACK FOOTER //
// ./src/containers/settings/Printer.js